import { useState } from 'react';
import { Form, Input, Button, Row, Col } from 'antd';
import { PasswordRequirementCheckBoxes } from '../../../components/forms/password.requirements';
import { showSnackbar } from '../../../components/snackbar';
import { translateThis } from '../../../helpers/language.helper';

export default function RegisterForm({ onSuccess }) {
    const [password, setPassword] = useState('');
    const [validPassword, setValidPassword] = useState({
        eightCharacter: false,
        containNumber: false,
        containUpperCase: false,
        containSpecialChar: false,
    });

    const validatePassword = (value) => {
        const rules = {
            eightCharacter: value.length > 7,
            containNumber: /\d/.test(value),
            containUpperCase: value !== value.toLowerCase(),
            containSpecialChar: /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(value),
        };
        setValidPassword(rules);
        const isStrong = rules.eightCharacter && rules.containNumber && rules.containUpperCase && rules.containSpecialChar;
        setPassword(isStrong ? value : '');
    };

    const onFinish = (formData) => {
        if (!password) {
            showSnackbar().failure('Please enter a valid password');
            return;
        }
        onSuccess({
            name: formData.name,
            lastName: formData.lastName,
            email: formData.email,
            password,
        });
    };

    return (
        <div className='login-form standard-form'>
            <Form
                name="register"
                onFinish={onFinish}
                layout="vertical"
                style={{ maxWidth: '375px', margin: '0 auto' }}
            >
                <Row gutter={12}>
                    <Col span={12}>
                        <Form.Item
                            label={translateThis('Name')}
                            name="name"
                            rules={[{ required: true, message: translateThis('Please enter your name!') }]}
                            style={{ marginBottom: '26px' }}
                        >
                            <Input placeholder={translateThis('Name')} />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item
                            label={translateThis('Last Name')}
                            name="lastName"
                            style={{ marginBottom: '26px' }}
                        >
                            <Input placeholder={translateThis('Last Name')} />
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item
                    label={translateThis('Email')}
                    name="email"
                    rules={[{ required: true, type: 'email', message: translateThis('Please enter a valid email!') }]}
                    style={{ marginBottom: '26px' }}
                >
                    <Input placeholder={translateThis('Email')} />
                </Form.Item>

                <Form.Item
                    className='password-input'
                    label={translateThis('Password')}
                    name="password"
                    rules={[{ required: true, message: translateThis('Please enter your password!') }]}
                >
                    <Input.Password
                        onChange={(e) => validatePassword(e.target.value)}
                        placeholder={translateThis('Password')}
                    />
                </Form.Item>

                <Form.Item>
                    <PasswordRequirementCheckBoxes rules={validPassword} />
                </Form.Item>

                <Form.Item>
                    <Button
                        className='auth-btn'
                        type="primary"
                        htmlType="submit"
                        block
                        disabled={!password}
                    >
                        {translateThis('Sign Up')}
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
}
